export default class Forecast {
  constructor(data) {
    this.customerId = data.customerId
    this.id = data.id || null
    this.soyAreaItems = data.soyAreaItems
    this.commercialProcessesItems = data.commercialProcessesItems
    this.areaIntactaLegal = parseFloat(data.areaIntactaLegal)
    this.areaTotal = parseFloat(data.areaTotal)
    this.commercialProcessesTotalArea = parseFloat(data.commercialProcessesTotalArea)
  }

  toApi() {
    return {
      ...this,
      customerId: parseInt(this.customerId) || null,
      id: parseInt(this.id) || null,
      soyAreaItems: this.soyAreaItems,
      commercialProcessesItems: this.commercialProcessesItems
    }
  }
}
